import { ParcelData } from './ParcelData';
import { ListingDetail } from './ListingDetail';
import { HistoricListing } from './HistoricListing';

export interface IParcelDetail {
    ParcelData?: ParcelData;
    Listings?: ListingDetail[];
}

export class ParcelDetail implements IParcelDetail {
    public ParcelData?: ParcelData;
    public Listings?: ListingDetail[];
    public PvsHistoricListings?: HistoricListing[];
    constructor(
        parcelDetail: any,
    ) {
        if (parcelDetail.parcelData) {
            this.ParcelData = new ParcelData(parcelDetail.parcelData);
        }
        if (parcelDetail.listings && parcelDetail.listings.length) {
            this.Listings = parcelDetail.listings.map( (listing: any) => new ListingDetail(listing) );
        }
        if (parcelDetail.pvsHistoricListings && parcelDetail.pvsHistoricListings.length) {
            this.PvsHistoricListings = parcelDetail.pvsHistoricListings.map( (historicListing: any) => new HistoricListing(historicListing) );
        }
    }
}

